// Auth helpers for the funnel user (not the admin)
const TOKEN_KEY = "np_user_token";

export function getUserToken() {
  try { return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || ""; }
  catch { return ""; }
}

export function setUserToken(token, remember = true) {
  try {
    if (remember) {
      localStorage.setItem(TOKEN_KEY, token);
      sessionStorage.removeItem(TOKEN_KEY);
    } else {
      sessionStorage.setItem(TOKEN_KEY, token);
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch { /* ignore */ }
}

export function clearUserToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}

export function authHeader() {
  const t = getUserToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
